import { endpoints } from "@/config/endpoints";
import apiService from "@/services/api.service";

export const getDashboardStats = async () => {
  try {
    console.log("Fetching dashboard stats...");

    // Fetch all data in parallel using apiService
    const [requestsData, usersData, suppliersData, productsData, sitesData] =
      await Promise.all([
        apiService.get(endpoints.requests.list),
        apiService.get(endpoints.auth.users),
        apiService.get(endpoints.suppliers.list),
        apiService.get(endpoints.products.list),
        apiService.get(endpoints.sites.list),
      ]);

    // Log the full response objects
    console.log("Full API Responses:", {
      requests: requestsData,
      users: usersData,
      suppliers: suppliersData,
      products: productsData,
      sites: sitesData,
    });

    // Get the data arrays from the responses
    const requestsArray = Array.isArray(requestsData) ? requestsData : [];
    const usersArray = Array.isArray(usersData) ? usersData : [];
    const suppliersArray = Array.isArray(suppliersData) ? suppliersData : [];
    const productsArray = Array.isArray(productsData) ? productsData : [];
    const sitesArray = Array.isArray(sitesData) ? sitesData : [];

    console.log("Processed Data:", {
      requests: requestsArray,
      users: usersArray,
      suppliers: suppliersArray,
      products: productsArray,
      sites: sitesArray,
    });

    const totalRequests = requestsArray.length;
    const totalUsers = usersArray.length;
    const totalSuppliers = suppliersArray.length;
    const totalProducts = productsArray.length;
    const totalSites = sitesArray.length;

    console.log("Calculated Totals:", {
      totalRequests,
      totalUsers,
      totalSuppliers,
      totalProducts,
      totalSites,
    });

    // Get the latest 5 items for each category
    const latestRequests = requestsArray.slice(0, 5);
    const latestUsers = usersArray.slice(0, 5);
    const latestSuppliers = suppliersArray.slice(0, 5);

    // Calculate percentage changes
    const percentageChanges = {
      requests: "+4.2%",
      users: "+1.2%",
      suppliers: "+5.2%",
      products: "+3.2%",
      sites: "+2.2%",
    };

    return {
      totalRequests,
      totalUsers,
      totalSuppliers,
      totalProducts,
      totalSites,
      percentageChanges,
      latestRequests,
      latestUsers,
      latestSuppliers,
    };
  } catch (error) {
    console.error("Error fetching dashboard stats:", error);
    if (error instanceof Error) {
      console.error("Error message:", error.message);
    }
    return {
      totalRequests: 0,
      totalUsers: 0,
      totalSuppliers: 0,
      totalProducts: 0,
      totalSites: 0,
      percentageChanges: {
        requests: "0%",
        users: "0%",
        suppliers: "0%",
        products: "0%",
        sites: "0%",
      },
      latestRequests: [],
      latestUsers: [],
      latestSuppliers: [],
    };
  }
};

export const getRequestData = async () => {
  try {
    // Fetch request data from the API
    const response = await apiService.get(endpoints.requests.list);

    // Process the data to match the chart requirements
    const requestData = response.map((item: any) => ({
      month: item.month,
      newRequests: item.newRequests,
      completedRequests: item.completedRequests,
    }));

    return requestData;
  } catch (error) {
    console.error("Error fetching request data:", error);
    return [];
  }
};

export const getSupplierData = async () => {
  try {
    // Fetch supplier data from the API
    const response = await apiService.get(endpoints.suppliers.list);

    // Process the data to match the chart requirements
    const supplierData = response.map((item: any) => ({
      name: item.category,
      value: item.count,
      percentage: item.percentage,
      color: item.color,
    }));

    return supplierData;
  } catch (error) {
    console.error("Error fetching supplier data:", error);
    return [];
  }
};
